import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.number.constructor";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
export default {
  name: "packageDetail",
  props: {
    packageIncludes: {
      type: [Array, String],
      default: function _default() {
        return [];
      }
    },
    // preferentialInstruction: {
    //     type: Array,
    //     default: () => []
    // },
    useNewPackageIncludes: [Number, String]
  },
  data: function data() {
    return {
      purchaseType: 1,
      countLine: 0,
      showMoreVisible: false,
      hasShowMore: false,
      shouldBeRendered: true,
      particalList: [],
      // 小于等于6的部分数据
      renderList: [],
      // 需要渲染的条目详情
      cPackageIncludes: []
    };
  },
  watch: {
    useNewPackageIncludes: {
      handler: function handler() {
        this.renderNewPackage && this.setProductDetail();
      },
      immediate: true
    }
  },
  computed: {
    renderNewPackage: function renderNewPackage() {
      return Boolean(this.useNewPackageIncludes && Array.isArray(this.packageIncludes) && this.packageIncludes.length > 0);
    },
    renderOldPackage: function renderOldPackage() {
      return Boolean(!this.useNewPackageIncludes && typeof this.packageIncludes == "string" && this.packageIncludes.length);
    },
    oldPackageIncludes: function oldPackageIncludes() {
      return this.packageIncludes.replace(/\n/g, "<br/>");
    }
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == "object" || (window.componentCenter = {});
    window.componentCenter.packageDetail = this;
  },
  methods: {
    // 判断查看更多是否展示
    setProductDetail: function setProductDetail() {
      this.cPackageIncludes = this.packageIncludes || [];
      // if ((this.preferentialInstruction || []).length) {
      //         this.cPackageIncludes.push({
      //             title: '特殊说明',
      //             includes: this.preferentialInstruction,
      //             totalPrice: -1,
      //             totalStock: -1
      //         });
      // }
      var packageIncludes = this.cPackageIncludes;
      var renderList = []; // 所有子项
      var particalList = []; // 所有子项
      var particalCount = 0;
      var particalNum = 6; // 默认展示行数
      var disabledALLBtn = true; // 是否禁用查看全部功能
      var _iterator = _createForOfIteratorHelper(packageIncludes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var outside = _step.value;
          var _iterator2 = _createForOfIteratorHelper(outside.includes),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var inside = _step2.value;
              renderList.push(inside);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        // 子项列表
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.renderList = renderList;
      // 超过6行， 显示查看全部
      if (renderList.length > particalNum && !disabledALLBtn) {
        this.showMoreVisible = true;
        // 大于6个子项的情况，构建一个只有6个的数组
        for (var index = 0; index < packageIncludes.length; index++) {
          particalCount += packageIncludes[index].includes.length;
          if (particalCount < particalNum) {
            particalList.push(packageIncludes[index]);
          } else {
            var lastItemLen = index > 0 ? packageIncludes[index - 1].includes.length : 0;
            var subItem = {
              title: packageIncludes[index].title,
              totalPrice: packageIncludes[index].totalPrice,
              totalStock: packageIncludes[index].totalStock,
              includes: packageIncludes[index].includes.slice(0, particalNum - lastItemLen)
            };
            particalList.push(subItem);
            break;
          }
        }
        this.particalList = particalList;
      } else {
        this.showMoreVisible = false;
        // 不足6个子项的情况, 全部渲染
        this.particalList = packageIncludes;
      }
    },
    showMoreList: function showMoreList() {
      this.showMoreVisible = false;
      this.hasShowMore = true;
      this.particalList = this.cPackageIncludes;
    }
  }
};